import { render } from "./MaterialsBeamers.vue?vue&type=template&id=14d8fadb"
import script from "./MaterialsBeamers.vue?vue&type=script&lang=js"
export * from "./MaterialsBeamers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__